import { forwardRef, type ComponentPropsWithRef } from "react";

import { Circle, cn, type CircleProps } from "@eisox/design-system";

/* -------------------------------------------------------------------------------------------------
 * Sensor
 * -----------------------------------------------------------------------------------------------*/

type Root = ComponentPropsWithRef<"div">;
const Root = forwardRef<HTMLDivElement, Root>(({ className, children, ...props }, ref) => (
  <div {...props} ref={ref} className={cn("flex items-center gap-[10px]", className)}>
    {children}
  </div>
));

Root.displayName = "Sensor.Root";

/* -------------------------------------------------------------------------------------------------
 * Icon
 * -----------------------------------------------------------------------------------------------*/

type Icon = CircleProps;
const Icon = forwardRef<HTMLDivElement, Icon>(({ className, children, ...props }, ref) => (
  <Circle.Root
    {...props}
    ref={ref}
    color="white"
    backgroundColor="darkGray"
    className={cn("md:h-[50px]! md:w-[50px]! h-[35px]! w-[35px]!", className)}
  >
    {children}
  </Circle.Root>
));
Icon.displayName = "Sensor.Icon";

/* -------------------------------------------------------------------------------------------------
 * Value
 * -----------------------------------------------------------------------------------------------*/

type Value = ComponentPropsWithRef<"p">;
const Value = forwardRef<HTMLParagraphElement, Value>(({ className, children, ...props }, ref) => (
  <p {...props} ref={ref} className={cn("font-semibold md:text-2xl text-md text-primary-white", className)}>
    {children}
  </p>
));
Value.displayName = "Sensor.Value";

/* -------------------------------------------------------------------------------------------------
 * Unity
 * -----------------------------------------------------------------------------------------------*/

type Unity = ComponentPropsWithRef<"span">;
const Unity = forwardRef<HTMLSpanElement, Unity>(({ className, children, ...props }, ref) => (
  <span
    {...props}
    ref={ref}
    className={cn("md:text-md font-normal align-top text-sm text-primary-dark-gray", className)}
  >
    {children}
  </span>
));
Unity.displayName = "Sensor.Unity";

export { Icon, Root, Unity, Value };
